// @flow
import { base64Encode } from '@finect/front-utils/base64';

type StoreType = {
  articles: Object,
  tagNextArticles: Object,
  articlesFeed: Object
};

export function articles(
  state: StoreType = {
    articles: {
      items: [],
      fetching: false,
      fetched: false,
      paging: {
        links: [],
        totalItems: 0,
        limit: 10
      }
    },
    tagNextArticles: {
      items: [],
      fetching: false,
      fetched: false,
      paging: {
        links: [],
        totalItems: 0,
        limit: 10
      }
    },
    articlesFeed: {
      items: [],
      // Cuantos articulos ha entregado el servidor, contando los que se descartan por duplicados.
      // Es el cursor de paginacion: si se usara items.length, en cuanto se descarta uno el offset
      // se queda atras, la peticion siguiente pide una ventana que ya tenemos, todo vuelve a salir
      // duplicado y el feed se queda pidiendo lo mismo en bucle sin anadir nada.
      received: 0,
      fetching: false,
      fetched: false,
      paging: {
        links: [],
        totalItems: 0,
        limit: 10
      }
    }
  },
  action: Object
) {
  switch (action.type) {
    case 'SET_ARTICLES': {
      const newState = { ...state };
      newState.articles = {
        ...state.articles,
        items: [
          ...state.articles.items,
          ...action.contents.map(item =>
            (item.type === 'article'
              ? {
                ...item,
                body: {
                  ...item.body,
                  text: base64Encode(item.body.text)
                }
              }
              : item))
        ],
        fetching: false,
        fetched: true,
        paging: action.paging
      };
      return { ...state, ...newState };
    }

    case 'SET_TAG_NEXT_ARTICLES': {
      const newState = { ...state };
      newState.tagNextArticles = {
        ...state.tagNextArticles,
        items: [
          ...state.tagNextArticles.items,
          ...action.contents.map(item =>
            (item.type === 'article'
              ? {
                ...item,
                body: {
                  ...item.body,
                  text: base64Encode(item.body.text)
                }
              }
              : item))
        ],
        fetching: false,
        fetched: true,
        paging: action.paging
      };
      return { ...state, ...newState };
    }

    case 'SET_TAG_NEXT_ARTICLES_FETCHING_STATUS': {
      const newState = { ...state };
      newState.tagNextArticles = {
        ...state.tagNextArticles,
        fetching: action.fetching,
        fetched: action.fetched || state.tagNextArticles.fetched
      };
      return { ...state, ...newState };
    }

    case 'CLEAR_TAG_NEXT_ARTICLES': {
      const newState = { ...state };
      newState.tagNextArticles = {
        ...state.tagNextArticles,
        items: [],
        fetching: false,
        fetched: false,
        paging: {
          links: [],
          totalItems: 0,
          limit: 10
        }
      };
      return { ...state, ...newState };
    }

    case 'SET_ARTICLES_FEED': {
      const newState = { ...state };

      // El feed pagina por offset sobre una lista ordenada por fecha descendente: si se publica un
      // artículo entre dos cargas, todo baja una posición y el que ocupaba el offset vuelve a
      // llegar. Sin deduplicar, se pinta dos veces y React recibe dos hijos con la misma key.
      const knownIds = new Set(state.articlesFeed.items.map(item => item.id));
      const incoming = action.contents.filter(item => !knownIds.has(item.id));

      newState.articlesFeed = {
        ...state.articlesFeed,
        items: [...state.articlesFeed.items, ...incoming],
        received: (state.articlesFeed.received || 0) + action.contents.length,
        fetching: false,
        fetched: true,
        paging: action.paging
      };
      return { ...state, ...newState };
    }

    case 'CLEAR_ARTICLES_FEED': {
      const newState = { ...state };
      newState.articlesFeed = {
        ...state.articlesFeed,
        items: [],
        received: 0,
        fetching: false,
        fetched: false,
        paging: {
          links: [],
          totalItems: 0,
          limit: 10
        }
      };
      return { ...state, ...newState };
    }

    case 'SET_ARTICLES_FETCHING_STATUS': {
      const newState = { ...state };
      newState.articles = {
        ...state.articles,
        fetching: action.fetching,
        fetched: action.fetched || state.articles.fetched
      };
      return { ...state, ...newState };
    }

    default:
      return state;
  }
}
